import { localeCodes } from '@ringcentral/rwc-utils/src/constants/locales';

type Locales = {
    // Language, like "en-US":"en-US" or "fr-CA":"fr-CA".
    [key: string]: string;
};

type BrandLocales = {
    // Brand, like 'rc_us', 'avaya' and etc...
    [key: string]: Locales;
};

const brand: string = process.env.BRAND ?? '';
const allBrandsLocales: BrandLocales =
    (process.env.BRAND_LANGUAGES as unknown as BrandLocales) ?? {};

// En US by default.
let brandLocales: Locales = { [localeCodes.enUS]: localeCodes.enUS };

// Retrieves available locales (languages) for current brand.
try {
    const locales = allBrandsLocales[brand];
    if (locales) {
        brandLocales = locales;
    }
} catch (e) {
    // Do nothing.
}

export default brandLocales;
